export enum TipoPeriodoEnum {
  Mes = 1,
  Ano = 2,
  Personalizado = 3,
  Todos = 4
}

export interface CallCenterFiltros {
  tipoPeriodo: TipoPeriodoEnum;
  mes?: number;
  ano: number;
  dataInicio?: string;
  dataFim?: string;
  feiraId?: string;
  listaId?: string;
  atendente?: string;
}

export interface TaxaQualificacaoResult {
  labels: string[];
  quantidades: number[];
  percentuais: number[];
  totalContatos: number;
  totalQualificados: number;
  totalNaoQualificados: number;
  taxaQualificacao: number;
}

export interface ContatosAtualizadosTemporalResult {
  labels: string[];
  quantidades: number[];
  totalContatos: number;
  mediaContatos: number;
}

export interface AproveitamentoListasResult {
  labels: string[];
  taxasQualificacao: number[];
  totalContatos: number[];
  totalQualificados: number[];
}

export interface StatusQualificadosResult {
  labels: string[];
  quantidades: number[];
  cores?: string[];
  totalQualificados: number;
}

export interface MensagensPorAtendenteResult {
  labels: string[];
  quantidades: number[];
  totalMensagens: number;
  mediaMensagens: number;
}

export interface ContatosSemMensagemResult {
  totalContatos: number;
  totalComMensagem: number;
  totalSemMensagem: number;
  percentualSemMensagem: number;
  contatosPorLista?: {
    listaNome: string;
    quantidade: number;
  }[];
}

export interface TaxaConversaoProjetosResult {
  totalQualificados: number;
  totalComProjeto: number;
  totalSemProjeto: number;
  taxaConversao: number;
  projetosGerados: number;
}

export interface TotalProjetosResult {
  totalProjetos: number;
}

export interface MensagensPorAtendenteDetalhado {
  nomeAtendente: string;
  quantidadeMensagens: number;
}

export interface PerformanceLista {
  listaId: string;
  nomeLista: string;
  totalContatos: number;
  totalQualificados: number;
  totalNaoQualificados: number;
  taxaQualificacao: number;
  totalMensagens: number;
  mensagensPorAtendente: MensagensPorAtendenteDetalhado[];
}

export interface PerformanceListasResult {
  listas: PerformanceLista[];
}

export interface ResumoPerformanceLista {
  listaId: string;
  nomeLista: string;
  totalContatos: number;
  totalQualificados: number;
  totalNaoQualificados: number;
  contatosComMensagem: number;
  contatosSemMensagem: number;
  totalMensagens: number;
  mensagensPorAtendente: MensagensPorAtendenteDetalhado[];
  taxaCoberturaMensagens: number;
  mediaMensagensPorContato: number;
}

export interface ResumoPerformanceListaResult {
  resumo: ResumoPerformanceLista;
}

export interface PerformanceFeiraResult {
  feiraId: string;
  nomeFeira: string;
  totalQualificados: number;
  totalNaoQualificados: number;
  totalProjetos: number;
}

export interface PerformanceFeirasResult {
  feiras: PerformanceFeiraResult[];
}

export interface MensagensPorFeiraDto {
  feiraId: string;
  nomeFeira: string;
  mensagensPorDia: number[];
  totalMensagens: number;
}

export interface MensagensPorDiaFeiraResult {
  labels: string[];
  feiras: MensagensPorFeiraDto[];
  totalMensagens: number;
  mediaMensagensPorDia: number;
}

export interface PerformanceAtendentesResult {
  labels: string[];
  mensagens: number[];
  contatosQualificados: number[];
  totalMensagens: number;
  totalContatosQualificados: number;
  mediaMensagensPorAtendente: number;
  mediaContatosQualificadosPorAtendente: number;
}

export interface CallCenterGraficosResult {
  taxaQualificacao: TaxaQualificacaoResult | null;
  contatosAtualizadosTemporal: ContatosAtualizadosTemporalResult | null;
  aproveitamentoListas: AproveitamentoListasResult | null;
  statusQualificados: StatusQualificadosResult | null;
  mensagensPorAtendente: MensagensPorAtendenteResult | null;
  contatosSemMensagem: ContatosSemMensagemResult | null;
  taxaConversaoProjetos: TaxaConversaoProjetosResult | null;
  totalProjetos: TotalProjetosResult | null;
}

